export class Scheduler{
	_running : boolean = false;
	_granularity : number = 1000;
	_maxTicks = 60*20;
	_ticks : number = 0;
	_functions : Map<string,Array<CallableFunction>>;
	_runner : any = undefined;

	constructor(){
		this._functions = new Map<string,Array<CallableFunction>>();

	}
	setGranularity(g:number):void{
		this._granularity=g;
	}

	executeTicks(tick:number):void{
		let id = ""+tick;
		if(this._functions.has(id)){
			let fns = this._functions.get(id);
			for(let fn of fns){
				//console.log("Got function on tick "+tick+ " running...");
				fn();
			}
		}
	}
	at(tick:number,fn){
		let id = tick+"";
		if(!this._functions.has(id)){
			this._functions.set(id,new Array<CallableFunction>());
		}
		if(tick > this._maxTicks){
			console.warn("invalid tick: "+tick+". increase max-ticks. ");
		}
		let fns = this._functions.get(id);
		fns.push(fn);
		this._functions.set(id,fns);
	}
	currentTick(){
		return this._ticks;
	}
	maxTicks(){
		return this._maxTicks;
	}
	granularity(){
		return this._granularity;
	}
	cancel(){
		if(this._runner != undefined){
			clearInterval(this._runner);
			this._runner = undefined;
		}
		return;
	}
	gotoTick(tick:number):void{
		this._ticks = tick;
	}
	isRunning(){
		return this._runner != undefined;
	}
	run(ticks?:number){
		if(ticks != undefined){
			this._maxTicks = ticks;
		}
		if(this._runner != undefined){
			console.warn("Scheduler already running.");
		}
		this._runner = setInterval(
				()=>{
					
					if(this._ticks >= this._maxTicks||this._runner == undefined){
						this.cancel();
						return;
					}
					this.executeTicks(this._ticks);
					this._ticks++;
				},
				this._granularity
		);
	}


}